import React from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/styles';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';
import EditIcon from '@material-ui/icons/Edit';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import SinglePlaylistNameNArtwork from '../../containers/Playlists/SinglePlaylistNameNArtwork';
import SinglePlaylistSongs from '../../containers/Playlists/SinglePlaylistSongs';
import Page from '../PageV2';
import {
  setAddSongsToPlaylistDialog,
  setEditPlaylistNameDialog,
  setDeletePlaylistDialog,
} from '../../lib/store/actions/playlists';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1.5),
  },
  icon: {
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
  },
  artworkAndName: {
    height: '350px',
    padding: theme.spacing(1.5),
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
}));

function MemberPage({
  onSetAddSongsToPlaylistDialog,
  onSetEditPlaylistNameDialog,
  onSetDeletePlaylistDialog,
}) {
  const classes = useStyles();

  const pageMenuItems = [
    {
      title: (
        <>
          <PlaylistAddIcon className={classes.icon} /> Add song(s) to playlist
          ...
        </>
      ),
      onClick: () => onSetAddSongsToPlaylistDialog(true),
    },
    {
      title: (
        <>
          <EditIcon className={classes.icon} /> Edit playlist name
        </>
      ),
      onClick: () => onSetEditPlaylistNameDialog(true),
    },
    {
      title: (
        <>
          <DeleteIcon className={classes.icon} /> Delete entire playlist
        </>
      ),
      onClick: () => onSetDeletePlaylistDialog(true),
    },
  ];

  return (
    <Page
      title={
        <>
          <LibraryMusicIcon className={classes.icon} /> Playlist Details
        </>
      }
      menuItems={pageMenuItems}
      gridContainerProps={{
        spacing: 3,
        direction: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      gridItemProps={{
        xs: 12,
        lg: 12,
      }}>
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={12} sm={12} md={12} lg={9}>
          <SinglePlaylistSongs />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Paper className={classes.artworkAndName}>
            <SinglePlaylistNameNArtwork />
          </Paper>
        </Grid>
      </Grid>
    </Page>
  );
}

export default connect(null, {
  onSetAddSongsToPlaylistDialog: setAddSongsToPlaylistDialog,
  onSetEditPlaylistNameDialog: setEditPlaylistNameDialog,
  onSetDeletePlaylistDialog: setDeletePlaylistDialog,
})(MemberPage);
